import axios from 'axios'

// Get API URL from env or default
let API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

// If page is loaded over HTTPS and API URL is HTTP, convert to HTTPS
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && API_URL.startsWith('http://')) {
  // Convert HTTP to HTTPS for mixed content security
  API_URL = API_URL.replace('http://', 'https://')
  console.warn('⚠️ Page loaded over HTTPS, converting API URL to HTTPS:', API_URL)
}

console.log('🔧 API Configuration:', {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  API_URL: API_URL,
  baseURL: `${API_URL}/api`,
  pageProtocol: typeof window !== 'undefined' ? window.location.protocol : 'unknown'
})

// Test connectivity
fetch(`${API_URL}/api/auth/login`, { method: 'GET' })
  .then(response => console.log('✅ Server connectivity test:', response.status))
  .catch(error => console.error('❌ Server connectivity test failed:', error.message))

export const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    console.log('🚀 API Request:', config.method?.toUpperCase(), config.url, config.baseURL + config.url)
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('❌ API Request Error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.status, response.config.url)
    return response
  },
  (error) => {
    console.error('❌ API Response Error:', error.message, error.code, error.config?.url)
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
